module.exports = __webpack_public_path__ + "img/bg-3.1.297c5e15.jpg";